export default __webpack_public_path__ + "static/media/GS_message_icon.6ed974ff.svg";